import { render, staticRenderFns } from "./ConcessionContract.vue?vue&type=template&id=a98cc65a&scoped=true"
import script from "./ConcessionContract.vue?vue&type=script&lang=js"
export * from "./ConcessionContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98cc65a",
  null
  
)

export default component.exports